import {
  addAddressError,
  removeAddressError,
  updateElectricityMeterAddressData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import { useDispatch, useSelector } from 'react-redux'
import useElectricityMeter from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/useElectricityMeter'
import {
  selectActiveAddress,
  selectCurrentAddressErrors,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { ELECTRICITY_METER_ID_LENGTH } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'

const useMeterInput = () => {
  const dispatch = useDispatch()
  const { country } = useSelector(selectAuthData)
  const skipCheck = country === 'de'
  const { pdlNo, isEditable, lastSentDate, isValidPdl, t, canRequestMeterData } = useElectricityMeter({
    type: 'client',
  })
  const activeAddress = useSelector(selectActiveAddress)
  const errors = useSelector(selectCurrentAddressErrors)
  const status = isValidPdl ? 'valid' : 'error'
  const searchPdlAvailableCountries = ['fr']
  const showPdlSearchButton = searchPdlAvailableCountries.includes(country)

  const electricityMeterUpdate = payload => {
    dispatch(
      updateElectricityMeterAddressData({
        data: payload,
        id: activeAddress,
      }),
    )
  }

  const meterIdOnBlurHandler = value => {
    const pdlNo = value?.replace(/ /g, '')
    electricityMeterUpdate({
      pdlNo,
      enedisAuth: false,
      consentDate: null,
      meterPower: null,
      meterOption: null,
      indexHC: null,
      indexBaseHP: null,
      readingDate: null,
    })

    if (!pdlNo || (!skipCheck && !ELECTRICITY_METER_ID_LENGTH[country]?.includes(pdlNo?.length))) {
      setIsValidPdl(false)
      return
    }

    dispatch({
      type: subscriptionFormActionsV2.METER_MODULE_VALIDATE_PDL_METER_SYNTAX_V2,
      meterId: pdlNo,
      callback: setIsValidPdl,
    })
  }

  const setIsValidPdl = value => {
    electricityMeterUpdate({ isValidPdl: value })
    if (value === false && (!pdlNo || pdlNo?.length === 0)) {
      return
    }
    if (value === false && pdlNo?.length > 0) {
      dispatch(
        addAddressError({
          data: { meter_id_elec: ['La syntaxe du PDL est incorrecte'] },
          id: activeAddress,
        }),
      )
      return
    }

    dispatch(removeAddressError({ id: activeAddress, key: 'meter_id_elec' }))
  }

  return {
    meterIdOnBlurHandler,
    pdlNo,
    isEditable,
    errors,
    lastSentDate,
    canRequestMeterData,
    meterStatus: pdlNo ? status : null,
    showPdlSearchButton,
    t,
  }
}

export default useMeterInput
